var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "demage"
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "left"
    }
  }, [_c("a-form-item", {
    staticClass: "name",
    attrs: {
      label: _vm.$t("文件名称")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("文件名称")
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-item", {
    staticClass: "name",
    attrs: {
      label: _vm.$t("状态")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("状态")
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, _vm._l(_vm.statusSelectList, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key,
        label: _vm.$t(item.name)
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1), _c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))])], 1), _vm.isAuth("home.claimsDocumentDelete") ? _c("a-button", {
    staticStyle: {
      margin: "20px 20px 0 0"
    },
    attrs: {
      type: "danger"
    },
    on: {
      click: _vm.batchDelete
    }
  }, [_vm._v(_vm._s(_vm.$t("批量删除")))]) : _vm._e(), _vm.isAuth("home.claimsDocumentStore") ? _c("a-button", {
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: _vm.onAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("新增文件")))]) : _vm._e(), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      "row-selection": {
        selectedRowKeys: _vm.selectedRowKeys,
        onChange: _vm.onSelectChange
      },
      columns: _vm.columns,
      "data-source": _vm.tableData,
      bordered: "",
      pagination: _vm.pagination,
      rowKey: "claimsDocumentId",
      defaultExpandAllRows: true
    },
    on: {
      change: _vm.tablePageChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (_, record, index) {
        return [_vm._v(_vm._s((_vm.pagination.current - 1) * _vm.pagination.pageSize + Number(index + 1)))];
      }
    }, {
      key: "format",
      fn: function (text) {
        return [_c("a-tooltip", {
          attrs: {
            placement: "topLeft",
            title: text
          }
        }, [_vm._v(_vm._s(text))])];
      }
    }, {
      key: "status",
      fn: function (text, record) {
        return [_vm.isAuth("home.claimsDocumentUpdate") ? _c("a-switch", {
          attrs: {
            "checked-children": _vm.$t("已启用"),
            "un-checked-children": _vm.$t("已禁用"),
            checked: _vm.isChecked(text === 1)
          },
          on: {
            change: checked => _vm.checkedStatus(checked, record.claimsDocumentId)
          }
        }) : _c("span", [_vm._v(_vm._s(text === 1 ? _vm.$t("已启用") : _vm.$t("已禁用")))])];
      }
    }, {
      key: "operation",
      fn: function (text, record) {
        return [_vm.isAuth("home.claimsDocumentEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.onEdit(record.claimsDocumentId);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("home.claimsDocumentDelete") ? _c("a-button", {
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.onDelete(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("add-modal", {
    ref: "addRef",
    on: {
      save: _vm.searchFun
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };